import React from 'react'
import ReactDOM from 'react-dom'
import apolloClient from './graphql/client'

import 'regenerator-runtime'

import { ApolloProvider } from '@apollo/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'

import { SENTRY_DSN, SENTRY_RELEASE } from './config/sentry'
import * as Sentry from '@sentry/react'

import './index.scss'

if (SENTRY_DSN && SENTRY_RELEASE) {
  Sentry.init({
    dsn: SENTRY_DSN as string,
    release: SENTRY_RELEASE as string
  })
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('eda-partner-app')
)
